import { FaUser, FaCog, FaBuilding, FaMobileAlt } from 'react-icons/fa';
import QueueManager from './QueueManager';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import ProfileEdit from './profile/ProfileEdit';
import SystemSettingsManager from './settings/SystemSettingsManager.jsx';
import CompanyInfoSettings from './settings/CompanyInfoSettings';
import MpesaSettings from './settings/MpesaSettings';

const VALID_TABS = ['Profile', 'CompanyInfo', 'SystemSettings', 'QueueManager', 'MpesaSettings'];

const Settings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = VALID_TABS.includes(searchParams.get('tab')) ? searchParams.get('tab') : 'Profile';

  const setActiveTab = (tab) => setSearchParams({ tab });

  const tabClass = (tab) =>
    `flex items-center py-2 md:py-4 px-3 md:px-6 border-b-2 focus:outline-none ${
      activeTab === tab
        ? 'border-orange-500 text-orange-600 font-medium'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
    }`;

  return (
    <>
      <div>
        <div className="mt-8 border-b border-gray-200">
          <nav className="-mb-px flex justify-around md:justify-start space-x-4 md:space-x-8" aria-label="Tabs">
            <button type="button" onClick={() => setActiveTab('Profile')} className={tabClass('Profile')}>
              <FaUser className="block text-xl mr-2 text-[#FF5733]" />
              <span className="hidden md:inline">Profile</span>
            </button>
            <button type="button" onClick={() => setActiveTab('CompanyInfo')} className={tabClass('CompanyInfo')}>
              <FaBuilding className="block text-xl" />
              <span className="hidden md:inline">Company Info</span>
            </button>
            <button type="button" onClick={() => setActiveTab('SystemSettings')} className={tabClass('SystemSettings')}>
              <FaCog className="block text-xl" />
              <span className="hidden md:inline">System Settings</span>
            </button>
            <button type="button" onClick={() => setActiveTab('QueueManager')} className={tabClass('QueueManager')}>
              <span className="block text-xl mr-2">
                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" className="inline-block align-middle">
                  <rect x="2" y="3" width="12" height="2" rx="1" />
                  <rect x="2" y="7" width="12" height="2" rx="1" />
                  <rect x="2" y="11" width="12" height="2" rx="1" />
                </svg>
              </span>
              <span className="hidden md:inline">Queue Manager</span>
            </button>
            <button type="button" onClick={() => setActiveTab('MpesaSettings')} className={tabClass('MpesaSettings')}>
              <FaMobileAlt className="block text-xl mr-2 text-orange-500" />
              <span className="hidden md:inline">M-Pesa</span>
            </button>
          </nav>
        </div>

        {activeTab === 'Profile' && <div className="mt-6 p-2"><ProfileEdit /></div>}
        {activeTab === 'CompanyInfo' && <div className="mt-6 p-2"><CompanyInfoSettings /></div>}
        {activeTab === 'SystemSettings' && <div className="mt-6 p-2"><SystemSettingsManager /></div>}
        {activeTab === 'QueueManager' && <div className="mt-6 p-2"><QueueManager /></div>}
        {activeTab === 'MpesaSettings' && <div className="mt-6 p-2"><MpesaSettings /></div>}
      </div>
    </>
  );
};

export default Settings;
